import React from 'react';
import { SUPPORT_TAB_HEADER } from '../../constants/interpreter.constants';
import { STORE_NAMES } from '../../constants/store.constants';
import { useSelector } from 'react-redux';
import ServiceNow from '../ServiceNow/ServiceNow';
import { SERVICE_NOW_KEY } from '../../constants/tab.constants';
import PortalAppSupportContainer from '../PortalAppSupportContainer/PortalAppSupportContainer';

const AddPortalAppSupport = () => {
  const { currentSupportTab } = useSelector(state => state?.[STORE_NAMES.SUPPORT_TAB_INFO]);
  return (
    <div className="vve-add-portal-app-support-container vve-container-topmargin">
      <header>
        <div className="vve-padding-bottom vve-portal-app-support-main-header">{SUPPORT_TAB_HEADER}</div>
      </header>
      <hr className="row vve-padding-top" />
      <div>
        {currentSupportTab !== SERVICE_NOW_KEY && <PortalAppSupportContainer></PortalAppSupportContainer>}
        {currentSupportTab === SERVICE_NOW_KEY && <ServiceNow></ServiceNow>}
      </div>
    </div>
  );
};

export default AddPortalAppSupport;
